<template>
  <div id="race-wrap">
    <h3>Race</h3>
    <select 
      class="race-select" 
      v-model="selectedRace" 
      @change="selectChange">
      <option disabled>Choose a Race</option>
      <option 
        v-for="race in races" 
        :key="race.title" 
        :value="race">
        {{ race.title }}
      </option>
    </select>
    <textarea 
      class="description" 
      ref="description"
      :readonly="selectedRace.title !== 'Other'"
      v-model="selectedRace.description">
    </textarea>
  </div>
</template>

<script>

export default {
  name: 'CharacterRace',
  methods: {
    selectChange() {
      if (this.selectedRace.title === 'Other') {
        this.$refs.description.focus();
      }
    }
  },
  computed: {
    races() {
      return this.$store.state.default.races;
    },
    selectedRace: {
      get(){
        return this.$store.state.character.race;
      },
      set(value) {
        this.$store.commit('updateCharacterProperty', { type: 'race', property: value });
      }
    }
  }
}
</script>
<style lang="css">
#race-wrap {
  width: 70%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.race-select {
  /* width: 50%; */
  -webkit-appearance: none;
  text-align: center;
  font-size: 20px;
  border: 1px solid #2c3e50;
  border-radius: 3px;
  padding: 0.5em;
}

.race-select:focus {
  outline: none;
}

.description {
  width: 100%;
  height: 5em;
  margin-top: 1em;
  padding: 0.5em;
  font-size: 20px;
  border: none;
  resize: none;
  overflow: inherit;
}

.description:focus {
  outline: none;
  border: 1px solid #2c3e50;
  border-radius: 3px;
}
</style>